module.exports = __webpack_public_path__ + "af480b956aa1d0b1cefd605686e75142.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-to-hang-out-after-school/IceCreamTruck1.jpg
// module id = 3562
// module chunks = 0